import { useAppStore } from '@/core/stores/appStore';

/**
 * Skip-passcode (`POST /v1/customers/skip-passcode`) is for email/password
 * login only — never UAE Pass, Emirates ID, or ADHA catalogue sessions.
 */
export function shouldInvokeSkipPasscodeApi(): boolean {
  const { auth, isAdhaJourney } = useAppStore.getState();
  if (isAdhaJourney) {
    return false;
  }
  return auth.loginMethod === 'password';
}
